import React from 'react';
import { __ } from '@wordpress/i18n';
import { H2 } from '../../../../ui/style';

const SiteTypography = () => {
	return (
		<>
			<H2>{__('Fonts', 'astra-sites')}</H2>
		</>
	)
}

export default SiteTypography;
